import { getAdminProducts } from "./download-database-api";

export const ENDPOINTS = {
    getDetails: "/database/getDetails",
    getSubscriptions: "/database/getSubscriptions",
    getAdminProducts: "/admindownload/getAdminProducts",
    getAdminProductsCategory: "/admindownload/admin-products/category",
    getAdminSearchParams: "/admindownload/getAdminSearchParams",
    getCustomerDetails: "/database/getCustomerDetails",
    sendDocuments: "/email/send-documents",
    prepareZip: "/download/prepare-zip",
    singleFileDownload: "/download/single-file",
    getGuestTokenDetails: "/guest-account/token/details",
    getGuestProducts: "/guestaccount/all-products-for-guest-user"
};